import { INTERVIEW_STEPS } from 'modules/hiring/shared/constants';
import { SectionTitle, Stepper } from 'modules/shared/components';
import { getStepState } from '../utils';

export default function InterviewStepper({ currentRound, onStepClick, status }) {
  const { activeStep, steps } = getStepState(INTERVIEW_STEPS, currentRound, status);

  return (
    <div className='column gap-3'>
      <SectionTitle title='Interview Rounds' />
      <Stepper steps={steps} activeStep={activeStep} onStepClick={onStepClick} />
    </div>
  );
}
